export default __webpack_public_path__ + "static/media/create_24px_outlined.3a7f565d.svg";